import React, { useEffect, useRef, useState } from 'react';
import constants from '../app/constants';
import utils from '../app/utils';
import Step from './Step';
import StepButton from './StepButton';
import AddToCartStepButton from './AddToCartStepButton';
import StepRadioGroup from './StepRadioGroup';
import TreatmentStep from './TreatmentStep';
import Image from './Image';
import Summary from './Summary';
import SimplePrescriptionForm from './SimplePrescriptionForm';
import FullPrescriptionForm from './FullPrescriptionForm';
import { useSelector, useDispatch } from 'react-redux';
import {
    setSelectedOptions,
    goToStep,
    clearSelectedOptions,
    setSelectedWarranty,
    openLearnMoreModal,
    closeLearnMoreModal,
    setStepValueSelected,
    setEditColorLens,
    setTreatmentOptions,
    setTreatmentOptionsPackages,
    setData,
    setInsuranceLoading,
    setBaseLensPackage,
    setTotalDiscount,
    setTotalPrice,
    setEditModeRemoveWarrantyCatEntryId,
    setInsuranceLogged,
    setFirstStep,
    setIsLensGaming,
    setProductImage,
    setSelectedPrescriptionObject,
    setIsMoreOneBrand,
    setProductImageOld,
    setIsFrameOnlySelected,
    setImageErrorMessage,
    setLensErrorMessage,
} from '../app/mainSlice';
import Scrollbars from 'react-custom-scrollbars';
import LearnMoreModal from './LearnMoreModal';
import { isMobile } from 'react-device-detect';

const StepContainer = props => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.main.data);
    const labels = useSelector(state => state.main.labels);
    const currentStep = useSelector(state => state.main.currentStep);
    const selectedOptions = useSelector(state => state.main.selectedOptions);
    const totalDiscount = useSelector(state => state.main.totalDiscount);
    const totalPrice = useSelector(state => state.main.totalPrice);
    const selectedPackage = useSelector(state => state.main.selectedPackage);
    const selectedWarranty = useSelector(state => state.main.selectedWarranty);
    const editModeCatEntryId = useSelector(state => state.main.editModeCatEntryId);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const editModeWarrantyCatEntryId = useSelector(state => state.main.editModeWarrantyCatEntryId);
    const extraTreatment = useSelector(state => state.main.extraTreatment);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const stepValueSelected = useSelector(state => state.main.stepValueSelected);
    const treatmentTypeLearnMore = useSelector(state => state.main.treatmentTypeLearnMore);
    const treatmentGroupLearnMore = useSelector(state => state.main.treatmentGroupLearnMore);
    const editColorLens = useSelector(state => state.main.editColorLens);
    const selectedColorOption = useSelector(state => state.main.selectedColorOption);
    const baseLensPackage = useSelector(state => state.main.baseLensPackage);
    const [isSingleType, setIsSingleType] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const treatmentOptions = useSelector(state => state.main.treatmentOptions);
    const isLensGaming = useSelector(state => state.main.isLensGaming);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const selectedPrescriptionObject = useSelector(state => state.main.selectedPrescriptionObject);
    const [hasPrescriptionStep, setHasPrescriptionStep] = useState(false);
    const isSimplePrescription = useSelector(state => state.main.isSimplePrescription);
    const isPrescriptionFormOpen = useSelector(state => state.main.isPrescriptionFormOpen);
    const isFrameOnlySelected = useSelector(state => state.main.isFrameOnlySelected);
    const isGVP = useSelector(state => state.main.isGVP);

    const tooltipRef = useRef(null);

    let firstLearnMoreStep = {};

    let checkSingleTypeBrand = true;

    const updateTotalPriceAndDiscount = currentPackage => {
        if (currentPackage) {
            let currentStartingPrice =
                parseFloat(props.config.data.frame.listPrice) +
                parseFloat(currentPackage.lensPackage.listPrice);
            let currentFinalPrice =
                parseFloat(currentPackage.frame.offerPrice) +
                parseFloat(currentPackage.lensPackage.offerPrice);

            if (isInsuranceEnabled) {
                currentFinalPrice = 0.0;

                if (currentPackage.frame.insPrice !== null) {
                    currentFinalPrice += parseFloat(currentPackage.frame.insPrice);
                } else {
                    currentFinalPrice += parseFloat(props.config.data.frame.listPrice);
                }

                if (currentPackage.lensPackage.insPrice !== null) {
                    currentFinalPrice += parseFloat(currentPackage.lensPackage.insPrice);
                } else {
                    currentFinalPrice += parseFloat(currentPackage.lensPackage.listPrice);
                }
            }

            dispatch(setTotalPrice(currentStartingPrice));
            dispatch(setTotalDiscount(currentStartingPrice - currentFinalPrice));
        }
    };

    const isStepOpen = step => {
        return constants.steps.indexOf(step) == currentStep;
    };

    const isStepConfirmed = step => {
        return constants.steps.indexOf(step) < currentStep;
    };

    const getConfirmedSelection = step => {
        if (selectedOptions !== null) {
            const stepOptions = constants.stepsOptionsMap[step];

            let confirmedValues = [];
            let confirmedExtraTreatment = null;

            stepOptions.forEach(stepOption => {
                if (
                    selectedOptions[stepOption] ||
                    (selectedPackage !== null && selectedPackage[stepOption])
                ) {
                    let selectedStepOption = null;

                    if (selectedOptions[stepOption]) {
                        selectedStepOption = selectedOptions[stepOption];
                    } else {
                        selectedStepOption = selectedPackage[stepOption];
                    }

                    if (step == 'treatments' && extraTreatment && !confirmedExtraTreatment) {
                        confirmedExtraTreatment =
                            labels.steps.treatments.extraTreatments[extraTreatment];

                        if (confirmedExtraTreatment) {
                            confirmedValues.push(confirmedExtraTreatment);
                        }
                    }

                    const stepOptionContent = data.content[stepOption];

                    if (stepOptionContent) {
                        const stepOptionValue = stepOptionContent[selectedStepOption];

                        if (stepOptionValue) {
                            confirmedValues.push(stepOptionValue);
                        }
                    }
                }
            });

            if (confirmedValues.length > 0) {
                return (
                    <>
                        {confirmedValues.map(confirmedValue => {
                            return (
                                <span key={confirmedValue.title}>
                                    {confirmedValue.imageFileName2 !== undefined ? (
                                        <Image
                                            imageClass="image-color-selected"
                                            url={baseURLs.projectImage}
                                            fileName={confirmedValue.imageFileName2}
                                            alt={`${confirmedValue.title} lens`}
                                        />
                                    ) : null}
                                    {confirmedValue.title}
                                </span>
                            );
                        })}
                    </>
                );
            } else {
                return null;
            }
        }
    };

    const handleSetSelectedOption = selectedOption => {
        dispatch(setSelectedOptions(selectedOption));

        if (editColorLens) {
            const key = 'color';
            const value = selectedColorOption.id;

            let treatmentColorOptions = {};
            treatmentColorOptions[key] = value;

            dispatch(setSelectedOptions(treatmentColorOptions));
            dispatch(setEditColorLens(!editColorLens));
        }

        //Treatments options
        const stepTreatmentOptions = Object.values(constants.stepsOptionsMap['treatments']).flat();

        let tempTreatmentOptions = {};

        for (let stepTreatmentOption of stepTreatmentOptions) {
            if (selectedOption[stepTreatmentOption]) {
                tempTreatmentOptions[stepTreatmentOption] = selectedOption[stepTreatmentOption];
            }
        }
        if (Object.keys(tempTreatmentOptions).length !== 0) {
            dispatch(setTreatmentOptions(tempTreatmentOptions));
        }

        if (isLensGaming) dispatch(setIsLensGaming(!isLensGaming));

        if (selectedOption.brand) {
            let productImage = props.config.data.frame.imageUrl;
            let frameOptions =
                constants.frameImages[
                    props.config.data.frame.brand.replace('-', '').replace(' ', '').toLowerCase()
                ];

            if (frameOptions) {
                let lensbrand = selectedOption.brand
                    .replace('-', '')
                    .replace(' ', '')
                    .toLowerCase();
                let framebrand = props.config.data.frame.brand
                    .replace('-', '')
                    .replace(' ', '')
                    .toLowerCase();

                if (framebrand == lensbrand && frameOptions[lensbrand]) {
                    productImage = frameOptions[lensbrand]
                        .replace('#PARTNUMBER#', props.config.data.frame.upc)
                        .replace('#MO#', props.config.data.frame.model)
                        .replace('#CO#', props.config.data.frame.color);
                } else {
                    productImage = frameOptions['unbranded']
                        .replace('#PARTNUMBER#', props.config.data.frame.upc)
                        .replace('#MO#', props.config.data.frame.model)
                        .replace('#CO#', props.config.data.frame.color);
                }

                //update frame images base endpoint if necessary
                let oldWordRegEx = new RegExp(constants.baseURLs.framesImage, 'g');
                productImage = productImage.replace(oldWordRegEx, baseURLs.framesImage);
                oldWordRegEx = new RegExp(constants.baseURLs.assetsCDN, 'g');
                productImage = productImage.replace(oldWordRegEx, baseURLs.assetsCDN);
            }

            dispatch(setProductImage(productImage));
        }
    };

    const stepLoadingAnalytics = stepName => {
        try {
            let products = utag_data.Products;

            if (selectedOptions && selectedOptions.type) {
                products[props.config.data.frame.upc].Type = 'RX';
            } else {
                products[props.config.data.frame.upc].Type = 'STD';
            }

            if (selectedOptions && selectedOptions.type) {
                products[props.config.data.frame.upc].LensType = selectedOptions.type;
            }
            if (selectedOptions && selectedOptions.brand) {
                products[props.config.data.frame.upc].LensBrand = selectedOptions.brand;
            }
            if (selectedOptions && selectedOptions.transition) {
                products[props.config.data.frame.upc].LensTransition = selectedOptions.transition;
            }
            if (selectedOptions && selectedOptions.thickness) {
                products[props.config.data.frame.upc].LensTechnology = selectedOptions.thickness;
            }
            if (
                treatmentOptions &&
                treatmentOptions.antiReflective &&
                treatmentOptions.antiReflective != undefined
            ) {
                products[props.config.data.frame.upc].LensAntiReflective =
                    treatmentOptions.antiReflective;
            }
            if (
                treatmentOptions &&
                treatmentOptions.transition &&
                treatmentOptions.transition != undefined
            ) {
                products[props.config.data.frame.upc].LensTechnology = treatmentOptions.transition;
            }
            if (
                treatmentOptions &&
                treatmentOptions.blueLight &&
                treatmentOptions.blueLight != undefined
            ) {
                products[props.config.data.frame.upc].LensAntiblue = treatmentOptions.blueLight;
            }
            if (extraTreatment) {
                products[props.config.data.frame.upc].LensTreatment = extraTreatment;
            }
            if (selectedColorOption) {
                products[props.config.data.frame.upc].LensColor = selectedColorOption.title;
            }
            if (selectedPackage && selectedPackage.lensPackage && selectedPackage.lensPackage.upc) {
                products[props.config.data.frame.upc].LensUPC = selectedPackage.lensPackage.upc;
            }

            let pageSection2 = 'Others';

            if (products[props.config.data.frame.upc].Brand) {
                if (
                    products[props.config.data.frame.upc].Brand == 'Ray-Ban' ||
                    products[props.config.data.frame.upc].Brand == 'Ray-Ban Jr'
                ) {
                    pageSection2 = 'RB';
                } else if (products[props.config.data.frame.upc].Brand == 'Oakley') {
                    pageSection2 = 'OO';
                } else if (products[props.config.data.frame.upc].Brand == 'Costa Del Mar') {
                    pageSection2 = 'CO';
                }
            }

            tealium_data2track.push({
                id: 'LensPanel-View',
                Page_Type: stepName,
                Page_Section1:
                    products[props.config.data.frame.upc].Category === 'SUN'
                        ? 'SunLensPanel'
                        : 'LensPanel',
                Page_Section2: pageSection2,
                Products: products,
            });
        } catch (error) {
            console.error(
                'Error during tealium_data2track push. Check if tealium_data2track exists in the window.\n' +
                    error
            );
        }
    };

    useEffect(() => {
        setHasPrescriptionStep(props.config.prescriptionModule && isSimplePrescription == false);
    }, [isSimplePrescription]);

    useEffect(() => {
        // Check if edit mode, isEditMode ensures that the edit mode is runned just once
        if (!isEditMode) {
            if (editModeCatEntryId && data && data.packages) {
                // Search for lens package with desired catEntryId
                const editPackages = data.packages.filter(currentPackage => {
                    if (
                        currentPackage &&
                        currentPackage.lensPackage &&
                        currentPackage.lensPackage.catEntryId == editModeCatEntryId
                    ) {
                        return currentPackage;
                    }
                });

                // If lens package with desired catEntryId is not present
                if (editPackages.length == 0) {
                    let errorMessage = 'Lens with catEntryId ' + editModeCatEntryId + ' not found';
                    console.error(errorMessage);

                    try {
                        tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'RX Configurator: Loading error',
                            Error_Details: errorMessage,
                            Error_Source: 'Client',
                        });
                    } catch (error) {
                        console.error(
                            'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
                        );
                    }

                    return;
                }

                // The array should not return more than one item
                const editPackage = editPackages[0];

                // Check if plano lens
                if (
                    !props.config.data.frameOnlyLensUPC ||
                    (props.config.data.frameOnlyLensUPC &&
                        editPackage.lensPackage.upc !== props.config.data.frameOnlyLensUPC)
                ) {
                    // Do this to not set null attributes in the Redux state
                    const stepOptions = Object.values(constants.stepsOptionsMap).flat();

                    let tempSelectedOption = {};

                    for (let stepOption of stepOptions) {
                        if (editPackage.lensPackage[stepOption]) {
                            tempSelectedOption[stepOption] = editPackage.lensPackage[stepOption];
                        }
                    }

                    handleSetSelectedOption(tempSelectedOption);
                    setIsEditMode(true);
                }
            }

            if (editModeWarrantyCatEntryId && data && data.warrantyOptions) {
                const selectedWarranty = data.warrantyOptions.filter(currentWarranty => {
                    if (currentWarranty && currentWarranty.id == editModeWarrantyCatEntryId) {
                        return currentWarranty;
                    }
                });

                if (selectedWarranty.length > 0) {
                    dispatch(setSelectedWarranty(selectedWarranty[0]));
                }

                setIsEditMode(true);
            }
        }
    }, [editModeCatEntryId, editModeWarrantyCatEntryId, data, props.config]);

    const handleWarrantyStep = (selectedOptionKey, selectedOption) => {
        let selectedWarranty = data.warrantyOptions.filter(value => {
            return value.id == selectedOption;
        });

        dispatch(setSelectedWarranty(selectedWarranty[0]));

        if (selectedWarranty.length == 0 && isEditMode) {
            dispatch(setEditModeRemoveWarrantyCatEntryId(editModeWarrantyCatEntryId));
        } else if (selectedWarranty.length > 0 && isEditMode) {
            dispatch(setEditModeRemoveWarrantyCatEntryId(null));
        }
    };

    //Handles steps tabIndex order
    const getStepTabIndex = index => {
        return index === 1 ? '1' : (index + index - 1).toString();
    };

    useEffect(() => {
        // Steps logic
        if (data !== null) {
            if (selectedOptions !== null) {
                const treatmentSelected =
                    (selectedOptions.noTreatments !== undefined ||
                        selectedOptions.polar !== undefined ||
                        selectedOptions.antiReflective !== undefined ||
                        selectedOptions.blueLight !== undefined ||
                        selectedOptions.transition !== undefined ||
                        selectedOptions.treatment !== undefined ||
                        selectedOptions.colorCategory !== undefined ||
                        selectedOptions.color !== undefined) &&
                    selectedOptions.warranty === undefined;
                const typeSelected =
                    selectedOptions.type !== undefined &&
                    selectedOptions.brand === undefined &&
                    selectedOptions.thickness === undefined &&
                    (!hasPrescriptionStep || selectedOptions.prescription === undefined);
                const prescriptionSelected =
                    hasPrescriptionStep &&
                    selectedOptions.type !== undefined &&
                    selectedOptions.brand === undefined &&
                    selectedOptions.thickness === undefined;
                const brandSelected =
                    selectedOptions.type !== undefined &&
                    selectedOptions.brand !== undefined &&
                    selectedOptions.thickness === undefined;
                const thicknessSelected =
                    selectedOptions.thickness !== undefined && !treatmentSelected;

                if (typeSelected) {
                    const singleBrand = props.getSingleBrand();
                    const selectedPackages = data.packages.filter(currentPackage => {
                        if (
                            selectedOptions.type &&
                            currentPackage.lensPackage.type == selectedOptions.type
                        ) {
                            return currentPackage;
                        }
                    });

                    // Prescription check
                    let hasPrescriptionStepVal = hasPrescriptionStep;

                    if (selectedPackages[0].lensPackage.rxValues == null) {
                        hasPrescriptionStepVal = null;
                        setHasPrescriptionStep(hasPrescriptionStepVal);
                        dispatch(setSelectedPrescriptionObject(null));
                    } else {
                        hasPrescriptionStepVal =
                            props.config.prescriptionModule && isSimplePrescription == false;
                        setHasPrescriptionStep(hasPrescriptionStepVal);
                    }

                    // Check if single brand
                    if (singleBrand && !hasPrescriptionStepVal) {
                        dispatch(
                            setSelectedOptions({
                                brand: singleBrand,
                            })
                        );
                    } else {
                        if (hasPrescriptionStepVal) {
                            dispatch(goToStep(constants.steps.indexOf('prescription')));
                        } else {
                            dispatch(goToStep(constants.steps.indexOf('brand')));
                        }
                    }
                } else if (prescriptionSelected) {
                    const singleBrand = props.getSingleBrand();

                    // Check if single brand
                    if (singleBrand) {
                        dispatch(
                            setSelectedOptions({
                                brand: singleBrand,
                            })
                        );
                    } else {
                        dispatch(goToStep(constants.steps.indexOf('brand')));
                    }
                } else if (brandSelected) {
                    dispatch(goToStep(constants.steps.indexOf('thickness')));
                } else if (thicknessSelected) {
                    dispatch(goToStep(constants.steps.indexOf('treatments')));
                } else if (treatmentSelected) {
                    dispatch(goToStep(constants.steps.indexOf('warranty')));
                }
            } else {
                const singleType = props.getSingleType();

                // Check if single type
                if (singleType) {
                    dispatch(
                        setSelectedOptions({
                            type: singleType,
                        })
                    );
                } else {
                    dispatch(goToStep(constants.steps.indexOf('type')));
                }
            }
        }
    }, [selectedOptions, data]);

    useEffect(() => {
        // Hide type and brand steps on first load
        if (data !== null && checkSingleTypeBrand) {
            const singleType = props.getSingleType();

            if (singleType) {
                setIsSingleType(true);
                dispatch(setFirstStep(constants.steps.indexOf('type')));
            }

            const singleBrand = props.getSingleBrand();

            if (singleBrand) {
                if (singleType) {
                    if (hasPrescriptionStep) {
                        dispatch(setFirstStep(constants.steps.indexOf('prescription')));
                    } else {
                        dispatch(setFirstStep(constants.steps.indexOf('brand')));
                    }
                }
            }

            checkSingleTypeBrand = false;
        }
    }, [data]);

    useEffect(() => {
        // Step scrolling
        if (constants.steps[currentStep]) {
            const stepElem = document.getElementById(constants.steps[currentStep]);

            if (stepElem) {
                stepElem.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        }

        switch (currentStep) {
            case constants.steps.indexOf('type'):
                stepLoadingAnalytics('LensType');
                break;
            case constants.steps.indexOf('brand'):
                stepLoadingAnalytics('LensBrand');
                break;
            case constants.steps.indexOf('thickness'):
                stepLoadingAnalytics('LensMaterial');
                break;
            case constants.steps.indexOf('treatments'):
                stepLoadingAnalytics('LensTreatment');
                break;
            case constants.steps.indexOf('warranty'):
                stepLoadingAnalytics('LensReview');
                break;
        }
    }, [currentStep]);

    useEffect(() => {
        // Get Insurance Discount on insurance enabled or on step change
        if (isInsuranceEnabled) {
            prepareInsuranceDiscount();
        } else {
            // Update final price
            if (currentStep == constants.steps.length - 1) {
                updateTotalPriceAndDiscount(selectedPackage);

                if (isMobile) {
                    let coordYIconInsurance;
                    let heightIconInsurance;
                    let coordYIconChat;
                    let heightIconChat;
                    let IconChat;
                    let IconInsurance = document.getElementById('insurance-modal');
                    if (IconInsurance) {
                        coordYIconInsurance = IconInsurance.getBoundingClientRect().top;
                        heightIconInsurance = IconInsurance.offsetHeight;
                    }
                    let IconChatArray = document.getElementsByClassName('cx-webchat-chat-button');
                    if (IconChatArray.length !== 0) {
                        IconChat = IconChatArray[0];
                        coordYIconChat = IconChat.getBoundingClientRect().top;
                        heightIconChat = IconChat.offsetHeight;
                    }
                    let elem = document.getElementById('main-content');
                    elem.addEventListener('scroll', () => {
                        let buttonAddToBag = document.getElementById('add-to-bag');
                        let coordYButton = buttonAddToBag.getBoundingClientRect().top;
                        let heightButton = buttonAddToBag.offsetHeight;

                        if (
                            coordYIconInsurance + heightIconInsurance > coordYButton &&
                            coordYIconInsurance < coordYButton + heightButton
                        )
                            IconInsurance.style.display = 'none';
                        else IconInsurance.style.display = 'block';
                        if (IconChatArray.length !== 0) {
                            if (
                                coordYIconChat + heightIconChat > coordYButton &&
                                coordYIconChat < coordYButton + heightButton
                            )
                                IconChat.style.display = 'none';
                            else IconChat.style.display = 'block';
                        }
                    });
                }
            }
        }
    }, [isInsuranceEnabled, currentStep]);

    const prepareInsuranceDiscount = () => {
        // RIA packages to be sent
        let filteredPackages = [];
        // Brand filtered packages
        let filteredBrands = [];
        // Thickness filtered packages
        let filteredThicknesses = [];

        switch (currentStep) {
            case constants.steps.indexOf('brand'):
                // Brand step
                data.packages
                    .filter(currentPackage => {
                        if (
                            selectedOptions &&
                            selectedOptions.type &&
                            currentPackage.lensPackage.type == selectedOptions.type &&
                            currentPackage.lensPackage.insurable == true &&
                            utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
                        ) {
                            return currentPackage;
                        }
                    })
                    .forEach(currentPackage => {
                        if (
                            filteredBrands.length == 0 ||
                            filteredBrands.indexOf(currentPackage.lensPackage.brand) < 0
                        ) {
                            // Add brand to filteredBrands list if brand has not been added
                            filteredPackages.push(currentPackage);
                            filteredBrands.push(currentPackage.lensPackage.brand);
                        } else if (
                            filteredBrands.length > 0 &&
                            filteredBrands.indexOf(currentPackage.lensPackage.brand) >= 0
                        ) {
                            // If brand has already been added in filteredBrands,
                            // find new lower listPrice brand package and add it to filteredPackages
                            let newFilteredPackages = [];

                            filteredPackages.forEach(filteredPackage => {
                                if (
                                    filteredPackage.lensPackage.brand ==
                                        currentPackage.lensPackage.brand &&
                                    parseFloat(filteredPackage.lensPackage.listPrice) >
                                        parseFloat(currentPackage.lensPackage.listPrice)
                                ) {
                                    newFilteredPackages.push(currentPackage);
                                } else {
                                    newFilteredPackages.push(filteredPackage);
                                }
                            });

                            filteredPackages = newFilteredPackages;
                        }
                    });
                break;
            case constants.steps.indexOf('thickness'):
                // Thickness step
                data.packages
                    .filter(currentPackage => {
                        if (
                            selectedOptions &&
                            selectedOptions.type &&
                            currentPackage.lensPackage.type == selectedOptions.type &&
                            selectedOptions.brand &&
                            currentPackage.lensPackage.brand == selectedOptions.brand &&
                            currentPackage.lensPackage.insurable == true &&
                            currentPackage.lensPackage.isBaseLens &&
                            utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
                        ) {
                            return currentPackage;
                        }
                    })
                    .forEach(currentPackage => {
                        if (
                            filteredThicknesses.length == 0 ||
                            filteredThicknesses.indexOf(currentPackage.lensPackage.thickness) < 0
                        ) {
                            // Add thickness to filteredThicknesses list if thickness has not been added
                            filteredPackages.push(currentPackage);
                            filteredThicknesses.push(currentPackage.lensPackage.thickness);
                        } else if (
                            filteredThicknesses.length > 0 &&
                            filteredThicknesses.indexOf(currentPackage.lensPackage.thickness) >= 0
                        ) {
                            // If brand has already been added in filteredBrands,
                            // find new lower listPrice brand package and add it to filteredPackages
                            let newFilteredPackages = [];

                            filteredPackages.forEach(pack => {
                                if (
                                    pack.lensPackage.type == currentPackage.lensPackage.type &&
                                    pack.lensPackage.brand == currentPackage.lensPackage.brand &&
                                    pack.lensPackage.thickness ==
                                        currentPackage.lensPackage.thickness &&
                                    parseFloat(pack.lensPackage.listPrice) >
                                        parseFloat(currentPackage.lensPackage.listPrice)
                                ) {
                                    newFilteredPackages.push(currentPackage);
                                } else {
                                    newFilteredPackages.push(pack);
                                }
                            });

                            filteredPackages = newFilteredPackages;
                        }
                    });
                break;
            case constants.steps.indexOf('treatments'):
                // Treatment step
                // Add only base lens package, further price evaluation on price selection
                if (baseLensPackage && baseLensPackage.lensPackage.insurable == true) {
                    filteredPackages.push(baseLensPackage);
                }
                break;
            case constants.steps.indexOf('warranty'):
                // Warranty step
                // Add only selected package and base lens package
                if (
                    selectedPackage &&
                    selectedPackage.lensPackage.insurable == true &&
                    baseLensPackage &&
                    baseLensPackage.lensPackage.insurable == true
                ) {
                    filteredPackages.push(selectedPackage);
                    filteredPackages.push(baseLensPackage);
                }
                break;
            default:
                // Other steps do not require insurance price evaluation
                filteredPackages = [];
                break;
        }

        if (isInsuranceEnabled && filteredPackages.length > 0) {
            getInsurancePrices(filteredPackages);
        }
    };

    const getInsurancePrices = filteredPackages => {
        let finalPricesUpdated = false;

        let _selectedFrame = {
            partNumber: props.config.data.frame.upc,
            listPrice: props.config.data.frame.listPrice,
        };

        // Filter out non insurable packages
        filteredPackages = filteredPackages.filter(currentPackage => {
            return (
                currentPackage.lensPackage.insurable == true &&
                currentPackage.lensPackage.insPrice == null
            );
        });

        if (props.config.insuranceModule && filteredPackages.length > 0) {
            dispatch(setInsuranceLoading(true));

            const errorMessage = 'ERROR while retrieving insurance discount';

            props.config.insuranceModule
                .getInsuranceDiscounts(_selectedFrame, filteredPackages)
                .then(
                    function (response) {
                        if (
                            response !== undefined &&
                            Array.isArray(response) &&
                            props.config.insuranceModule.isEnabled()
                        ) {
                            console.log('Insurance discount loaded');

                            if (response.length > 0) {
                                let tempData = utils.deepCopy(data);
                                let updatedPackages = [];

                                tempData.packages.forEach(currentPackage => {
                                    let tempPackage = currentPackage;

                                    for (let i = 0; i < response.length; i++) {
                                        if (
                                            currentPackage.lensPackage.upc ==
                                            response[i].lensPackage.upc
                                        ) {
                                            tempPackage = response[i];

                                            if (
                                                baseLensPackage !== null &&
                                                tempPackage.lensPackage.upc ==
                                                    baseLensPackage.lensPackage.upc
                                            ) {
                                                dispatch(setBaseLensPackage(tempPackage));
                                            }

                                            break;
                                        }
                                    }

                                    updatedPackages.push(tempPackage);
                                });

                                tempData.packages = updatedPackages;
                                dispatch(setData(tempData));

                                // TODO check
                                if (currentStep == constants.steps.length - 1) {
                                    updateTotalPriceAndDiscount(selectedPackage);
                                    finalPricesUpdated = true;
                                }
                            }

                            dispatch(setInsuranceLoading(false));
                        } else {
                            throw new Error(errorMessage);
                        }
                    },
                    function (error) {
                        throw new Error(errorMessage);
                    }
                )
                .catch(error => {
                    console.error(errorMessage);

                    try {
                        tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'RX Configurator: Loading error',
                            Error_Details: errorMessage,
                            Error_Source: 'Client',
                        });
                    } catch (error) {
                        console.error(
                            'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
                        );
                    }

                    dispatch(setInsuranceLoading(false));

                    if (!props.config.insuranceModule.isLogged()) {
                        dispatch(setInsuranceLogged(false));
                    }
                });
        }

        // TODO check
        if (currentStep == constants.steps.length - 1 && !finalPricesUpdated) {
            updateTotalPriceAndDiscount(selectedPackage);
        }
    };

    const handleEditStep = step => {
        let clearOptions = [];

        const nextSteps = constants.steps.slice(
            constants.steps.indexOf(step),
            constants.steps.length
        );

        nextSteps.forEach(nextStep => {
            clearOptions.push(constants.stepsOptionsMap[nextStep]);
        });

        if (constants.steps.indexOf(step) == 0 && !isSimplePrescription) {
            dispatch(setSelectedPrescriptionObject(null));
        }

        dispatch(clearSelectedOptions(clearOptions.flat()));
        dispatch(setEditColorLens(false));
        dispatch(setTreatmentOptions(null));
        dispatch(setTreatmentOptionsPackages(null));
        dispatch(setBaseLensPackage(null));
        dispatch(setIsLensGaming(false));
        dispatch(setProductImageOld(null));
        dispatch(setImageErrorMessage(false));
        dispatch(setLensErrorMessage(false));
    };

    const renderTypeStepContent = (isLearnMore = false) => {
        let visibleTypes = {};

        data.packages
            .filter(currentPackage => {
                if (utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)) {
                    return currentPackage;
                }
            })
            .forEach(currentPackage => {
                const currentType = currentPackage.lensPackage.type;
                const currentTypeContent = data.content.type[currentType];

                if (currentTypeContent && !visibleTypes[currentType]) {
                    visibleTypes[currentType] = {
                        key: currentType,
                        content: currentTypeContent,
                        sequence: currentTypeContent.sequence,
                        frameOnlyPackage:
                            currentPackage.lensPackage.upc == props.config.data.frameOnlyLensUPC
                                ? currentPackage
                                : null,
                    };
                }
            });

        const types = Object.values(visibleTypes).sort(utils.sortBySequence);

        return types.map((currentType, index) => {
            if (currentType.frameOnlyPackage !== null && props.config.data.frameOnlyLensUPC) {
                return (
                    <AddToCartStepButton
                        key={currentType.key}
                        imageFileName={currentType.content.imageFileName}
                        imageAlt={currentType.content.title}
                        title={currentType.content.title}
                        description={currentType.content.description}
                        dataElementId="X_X_LensPanel_Type-Choose"
                        dataDescription={currentType.content.title}
                        frameOnlyPackage={currentType.frameOnlyPackage}
                        config={props.config}
                    />
                );
            } else {
                return (
                    <StepButton
                        key={currentType.key}
                        imageFileName={currentType.content.imageFileName}
                        imageAlt={currentType.content.title}
                        title={currentType.content.title}
                        description={currentType.content.description}
                        dataElementId="X_X_LensPanel_Type-Choose"
                        dataDescription={currentType.content.title}
                        isLearnMore={isLearnMore}
                        isLearnMoreSelected={
                            isLearnMore && stepValueSelected['type'] === currentType.key
                        }
                        isBestPrescription={false}
                        handleClick={
                            isLearnMore
                                ? () => {
                                      if (stepValueSelected['type'] !== currentType.key) {
                                          dispatch(setIsFrameOnlySelected(false));
                                          dispatch(
                                              setStepValueSelected({
                                                  type: currentType.key,
                                              })
                                          );
                                      }
                                  }
                                : () => {
                                      dispatch(setIsFrameOnlySelected(false));
                                      handleSetSelectedOption({
                                          type: currentType.key,
                                      });
                                  }
                        }
                        handleAddButton={() => {
                            handleSetSelectedOption({
                                type: currentType.key,
                            });
                            dispatch(closeLearnMoreModal());
                        }}
                    />
                );
            }
        });
    };

    const renderPrescriptionTooltipContent = () => {
        return (
            selectedPrescriptionObject &&
            !hasPrescriptionStep && (
                <>
                    <table className="prescription-form-table">
                        <thead>
                            <tr>
                                <th />
                                <th className="right">OD (Right eye)</th>
                                <th className="left">OS (Left eye)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="left-label">SPH</div>
                                </td>
                                <td>
                                    <div className="rx-value bold">
                                        {parseFloat(selectedPrescriptionObject.SPH.OD)}
                                    </div>
                                </td>
                                <td>
                                    <div className="rx-value bold left">
                                        {parseFloat(selectedPrescriptionObject.SPH.OS)}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="left-label">CYL</div>
                                </td>
                                <td>
                                    <div className="rx-value bold">
                                        {selectedPrescriptionObject.CYL
                                            ? parseFloat(selectedPrescriptionObject.CYL.OD)
                                            : '-'}
                                    </div>
                                </td>
                                <td>
                                    <div className="rx-value bold left">
                                        {selectedPrescriptionObject.CYL
                                            ? parseFloat(selectedPrescriptionObject.CYL.OS)
                                            : '-'}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {selectedPrescriptionObject.ADD == true && (
                        <label className="lc-control lc-control--checkbox add-control">
                            {labels.prescription.addLabel}
                            <input
                                type="checkbox"
                                name="haveAdd"
                                id="haveAdd"
                                checked="checked"
                                disabled="true"
                            />
                            <div className="lc-control__indicator"></div>
                        </label>
                    )}
                </>
            )
        );
    };

    const renderPrescriptionStepContent = () => {
        const filteredPackages = data.packages.filter(currentPackage => {
            if (
                selectedOptions &&
                selectedOptions.type &&
                currentPackage.lensPackage.type == selectedOptions.type
            ) {
                return currentPackage;
            }
        });

        if (filteredPackages.length > 0 && filteredPackages[0].lensPackage.rxValues) {
            const isFullPrescription =
                filteredPackages.length > 0
                    ? filteredPackages[0].lensPackage.rxValues &&
                      filteredPackages[0].lensPackage.rxValues.add != null &&
                      filteredPackages[0].lensPackage.rxValues.add.min &&
                      filteredPackages[0].lensPackage.rxValues.add.max
                    : false;
            return (
                <FullPrescriptionForm
                    config={props.config}
                    isFormVisible={isStepOpen('prescription')}
                    handleConfirmPrescription={handleSetSelectedOption}
                    isFullPrescription={isFullPrescription}
                />
            );
        } else {
            return null;
        }
    };

    const renderBrandStepContent = (isLearnMore = false) => {
        let visibleBrands = {};
        let i = 0;

        data.packages
            .filter(currentPackage => {
                if (
                    selectedOptions &&
                    selectedOptions.type &&
                    currentPackage.lensPackage.type == selectedOptions.type &&
                    utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
                ) {
                    return currentPackage;
                }
            })
            .forEach(currentPackage => {
                const currentBrand = currentPackage.lensPackage.brand;
                const currentBrandContent = data.content.brand[currentBrand];

                // If brand has content and has not been shown yet
                if (currentBrandContent && !visibleBrands[currentBrand]) {
                    // Get all packages with the current brand and selected type
                    const brandPackages = data.packages.filter(brandPackage => {
                        if (
                            selectedOptions &&
                            selectedOptions.type &&
                            brandPackage.lensPackage.type == selectedOptions.type &&
                            brandPackage.lensPackage.brand == currentBrand &&
                            utils.hasValidPrescription(brandPackage, selectedPrescriptionObject)
                        ) {
                            return brandPackage;
                        }
                    });

                    // Get first current brand package prices
                    let firstBrandPrices = {
                        listPrice: brandPackages[0].lensPackage.listPrice,
                        offerPrice: brandPackages[0].lensPackage.offerPrice,
                    };

                    // Check if insurance is enabled, get insurance prices
                    if (isInsuranceEnabled) {
                        // Insurance price fallback
                        if (brandPackages[0].lensPackage.insPrice !== null) {
                            firstBrandPrices.offerPrice = parseFloat(
                                brandPackages[0].lensPackage.insPrice
                            );
                        } else {
                            firstBrandPrices.offerPrice = parseFloat(
                                brandPackages[0].lensPackage.listPrice
                            );
                        }
                    } else if (brandPackages[0].frame.promoType === constants.promoTypes.GVP) {
                        // Check if GVP package
                        firstBrandPrices = {
                            listPrice:
                                parseFloat(props.config.data.frame.listPrice) +
                                parseFloat(brandPackages[0].lensPackage.listPrice),
                            offerPrice:
                                parseFloat(brandPackages[0].frame.offerPrice) +
                                parseFloat(brandPackages[0].lensPackage.offerPrice),
                        };
                    }

                    // Get minimum list and offer prices
                    const prices = brandPackages.reduce((prevPackagePrices, brandPackage) => {
                        let brandPackagePrices = {
                            listPrice: parseFloat(brandPackage.lensPackage.listPrice),
                            offerPrice: parseFloat(brandPackage.lensPackage.offerPrice),
                        };

                        // Check if insurance is enabled, get insurance prices
                        if (isInsuranceEnabled) {
                            // Insurance price fallback
                            if (brandPackage.lensPackage.insPrice !== null) {
                                brandPackagePrices.offerPrice = parseFloat(
                                    brandPackage.lensPackage.insPrice
                                );
                            } else {
                                brandPackagePrices.offerPrice = parseFloat(
                                    brandPackage.lensPackage.listPrice
                                );
                            }
                        } else if (brandPackage.frame.promoType === constants.promoTypes.GVP) {
                            // Check if GVP package
                            brandPackagePrices = {
                                listPrice:
                                    parseFloat(props.config.data.frame.listPrice) +
                                    parseFloat(brandPackage.lensPackage.listPrice),
                                offerPrice:
                                    parseFloat(brandPackage.frame.offerPrice) +
                                    parseFloat(brandPackage.lensPackage.offerPrice),
                            };
                        }

                        return brandPackagePrices.listPrice < prevPackagePrices.listPrice
                            ? brandPackagePrices
                            : prevPackagePrices;
                    }, firstBrandPrices);

                    visibleBrands[currentBrand] = {
                        key: currentBrand,
                        content: currentBrandContent,
                        prices: prices,
                        sequence: currentBrandContent.sequence,
                    };
                }
            });

        // Sort visible brands by sequence
        const brands = Object.values(visibleBrands).sort(utils.sortBySequence);

        if (brands.length >= 2) dispatch(setIsMoreOneBrand(true));
        else dispatch(setIsMoreOneBrand(false));

        return brands.map((currentBrand, index) => {
            i++;
            firstLearnMoreStep[i] = React.createRef();

            return (
                <StepButton
                    key={currentBrand.key}
                    tabIndex={isLearnMoreModalOpen ? getStepTabIndex(i) : null}
                    imageFileName={currentBrand.content.imageFileName}
                    imageAlt={currentBrand.content.title}
                    title={currentBrand.key}
                    subtitle={currentBrand.content.title}
                    description={currentBrand.content.description}
                    dataElementId={
                        isLearnMore
                            ? 'X_X_LensPanel_Brand-LearnMoreSee'
                            : 'X_X_LensPanel_Brand-Choose'
                    }
                    dataDescription={currentBrand.content.title}
                    price={currentBrand.prices.listPrice}
                    discount={
                        parseFloat(currentBrand.prices.listPrice) -
                        parseFloat(currentBrand.prices.offerPrice)
                    }
                    startingAt={true}
                    isLearnMore={isLearnMore}
                    isLearnMoreSelected={
                        isLearnMore && stepValueSelected['brand'] === currentBrand.key
                    }
                    isBestPrescription={false}
                    handleClick={
                        isLearnMore
                            ? () => {
                                  if (stepValueSelected['brand'] !== currentBrand.key) {
                                      dispatch(
                                          setStepValueSelected({
                                              brand: currentBrand.key,
                                          })
                                      );
                                  }
                              }
                            : () => {
                                  handleSetSelectedOption({
                                      brand: currentBrand.key,
                                  });
                              }
                    }
                    handleAddButton={() => {
                        handleSetSelectedOption({
                            brand: currentBrand.key,
                        });
                        dispatch(closeLearnMoreModal());
                    }}
                    isInsuranceEnabled={isInsuranceEnabled}
                    isInsuranceLoading={isInsuranceLoading}
                    firstLearnMore={isLearnMore ? firstLearnMoreStep[i] : null}
                />
            );
        });
    };

    const renderThicknessStepContent = (isLearnMore = false) => {
        let visibleThickness = {};
        let numberThicknessTile = 0;
        let i = 0;

        data.packages
            .filter(currentPackage => {
                if (
                    selectedOptions &&
                    selectedOptions.type &&
                    currentPackage.lensPackage.type == selectedOptions.type &&
                    selectedOptions.brand &&
                    currentPackage.lensPackage.brand == selectedOptions.brand &&
                    utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
                ) {
                    return currentPackage;
                }
            })
            .forEach(currentPackage => {
                const currentThickness = currentPackage.lensPackage.thickness;
                const currentThicknessContent = data.content.thickness[currentThickness];

                // If thickness has content and has not been shown yet
                if (currentThicknessContent && !visibleThickness[currentThickness]) {
                    // Get all packages with the current thickness and selected type and brand
                    const thicknessPackages = data.packages.filter(thicknessPackage => {
                        if (
                            selectedOptions &&
                            selectedOptions.type &&
                            thicknessPackage.lensPackage.type == selectedOptions.type &&
                            selectedOptions.brand &&
                            thicknessPackage.lensPackage.brand == selectedOptions.brand &&
                            thicknessPackage.lensPackage.thickness == currentThickness &&
                            utils.hasValidPrescription(thicknessPackage, selectedPrescriptionObject)
                        ) {
                            return thicknessPackage;
                        }
                    });

                    if (thicknessPackages.length > 0) {
                        // Get first current thickness package prices
                        let firstThicknessPrices = {
                            listPrice: thicknessPackages[0].lensPackage.listPrice,
                            offerPrice:
                                isInsuranceEnabled &&
                                thicknessPackages[0].lensPackage.insPrice !== null
                                    ? thicknessPackages[0].lensPackage.insPrice
                                    : thicknessPackages[0].lensPackage.offerPrice,
                        };

                        // Check if GVP package
                        if (thicknessPackages[0].frame.promoType === constants.promoTypes.GVP) {
                            firstThicknessPrices = {
                                listPrice:
                                    parseFloat(props.config.data.frame.listPrice) +
                                    parseFloat(thicknessPackages[0].lensPackage.listPrice),
                                offerPrice:
                                    parseFloat(thicknessPackages[0].frame.offerPrice) +
                                    parseFloat(thicknessPackages[0].lensPackage.offerPrice),
                            };
                        }

                        // Get minimum list and offer prices
                        const prices = thicknessPackages.reduce(
                            (prevPackagePrices, thicknessPackage) => {
                                let thicknessPackagePrices = {
                                    listPrice: parseFloat(thicknessPackage.lensPackage.listPrice),
                                    offerPrice: parseFloat(thicknessPackage.lensPackage.offerPrice),
                                };

                                // Check if insurance is enabled, get insurance prices
                                if (isInsuranceEnabled) {
                                    // Insurance price fallback
                                    if (thicknessPackage.lensPackage.insPrice !== null) {
                                        thicknessPackagePrices.offerPrice = parseFloat(
                                            thicknessPackage.lensPackage.insPrice
                                        );
                                    } else {
                                        thicknessPackagePrices.offerPrice = parseFloat(
                                            thicknessPackage.lensPackage.listPrice
                                        );
                                    }
                                } else if (
                                    thicknessPackage.frame.promoType === constants.promoTypes.GVP
                                ) {
                                    // Check if GVP package
                                    thicknessPackagePrices = {
                                        listPrice:
                                            parseFloat(props.config.data.frame.listPrice) +
                                            parseFloat(thicknessPackage.lensPackage.listPrice),
                                        offerPrice:
                                            parseFloat(thicknessPackage.frame.offerPrice) +
                                            parseFloat(thicknessPackage.lensPackage.offerPrice),
                                    };
                                }

                                return thicknessPackagePrices.listPrice <
                                    prevPackagePrices.listPrice
                                    ? thicknessPackagePrices
                                    : prevPackagePrices;
                            },
                            firstThicknessPrices
                        );

                        visibleThickness[currentThickness] = {
                            key: currentThickness,
                            content: currentThicknessContent,
                            prices: prices,
                            sequence: currentThicknessContent.sequence,
                        };
                    }
                }
            });

        // Sort visible thickness by sequence
        const thicknesses = Object.values(visibleThickness).sort(utils.sortBySequence);
        numberThicknessTile = thicknesses.length;

        return thicknesses.map((currentThickness, index) => {
            i++;
            firstLearnMoreStep[i] = React.createRef();

            return (
                <StepButton
                    key={currentThickness.key}
                    tabIndex={isLearnMoreModalOpen ? getStepTabIndex(i) : null}
                    imageFileName={currentThickness.content.imageFileName}
                    imageAlt={currentThickness.content.title}
                    title={currentThickness.content.title}
                    description={currentThickness.content.description}
                    dataElementId={
                        isLearnMore
                            ? 'X_X_LensPanel_Material-LearnMoreSee'
                            : 'X_X_LensPanel_Material-Choose'
                    }
                    dataDescription={currentThickness.content.title}
                    price={currentThickness.prices.listPrice}
                    discount={
                        parseFloat(currentThickness.prices.listPrice) -
                        parseFloat(currentThickness.prices.offerPrice)
                    }
                    isLearnMore={isLearnMore}
                    isLearnMoreSelected={
                        isLearnMore && stepValueSelected['thickness'] === currentThickness.key
                    }
                    isBestPrescription={false}
                    handleClick={
                        isLearnMore
                            ? () => {
                                  if (stepValueSelected['thickness'] !== currentThickness.key) {
                                      dispatch(
                                          setStepValueSelected({
                                              thickness: currentThickness.key,
                                          })
                                      );
                                  }
                              }
                            : () => {
                                  handleSetSelectedOption({
                                      thickness: currentThickness.key,
                                  });
                              }
                    }
                    startingAt={isGVP}
                    handleAddButton={() => {
                        handleSetSelectedOption({
                            thickness: currentThickness.key,
                        });
                        dispatch(closeLearnMoreModal());
                    }}
                    isInsuranceEnabled={isInsuranceEnabled}
                    isInsuranceLoading={isInsuranceLoading}
                    badge={currentThickness.content.badge}
                    firstLearnMore={isLearnMore ? firstLearnMoreStep[i] : null}
                    onlyOne={numberThicknessTile === 1}
                />
            );
        });
    };

    const handleLearnMore = (treatmentType = null, treatmentGroup = null) => {
        dispatch(
            openLearnMoreModal({
                treatmentTypeLearnMore: treatmentType,
                treatmentGroupLearnMore: treatmentGroup,
            })
        );
    };

    const getLearnMoreParam = step => {
        switch (step) {
            case 0:
                return {
                    stepName: 'type',
                    renderMethod: renderTypeStepContent,
                };
            case 2:
                return {
                    stepName: 'brand',
                    renderMethod: renderBrandStepContent,
                };
            case 3:
                return {
                    stepName: 'thickness',
                    renderMethod: renderThicknessStepContent,
                };
            case 4:
                return {
                    stepName: 'treatments',
                    renderMethod: () => {},
                    treatmentType: treatmentTypeLearnMore,
                    treatmentGroup: treatmentGroupLearnMore,
                };
            default:
                return { stepName: '', renderMethod: () => {} };
        }
    };

    return (
        <>
            <LearnMoreModal
                isOpen={isLearnMoreModalOpen}
                closeModal={() => dispatch(closeLearnMoreModal())}
                config={props.config}
                step={getLearnMoreParam(currentStep).stepName}
                renderStepContent={getLearnMoreParam(currentStep).renderMethod}
                treatmentType={getLearnMoreParam(currentStep).treatmentType}
                treatmentGroup={getLearnMoreParam(currentStep).treatmentGroup}
                firstLearnMoreStep={firstLearnMoreStep}
                handleUpdateTotalPriceAndDiscount={updateTotalPriceAndDiscount}
            />
            <Scrollbars
                style={!isMobile ? { flex: '0 0 544px' } : null}
                hideTracksWhenNotNeeded
                renderView={props => (
                    <div
                        {...props}
                        id="scroll-view-steps"
                        className="scroll-view-steps"
                        style={{}}
                    />
                )}
                renderTrackVertical={props => (
                    <div {...props} className="scroll-track-vertical-steps" style={{}} />
                )}
                renderThumbVertical={props => (
                    <div {...props} className="scroll-thumb-vertical-steps" />
                )}
            >
                <div id="stepContainer" className="step-container">
                    <div className="step-inner-container">
                        {data != null ? (
                            <>
                                <Step
                                    key="type"
                                    id="type"
                                    config={props.config}
                                    isVisible={!isSingleType}
                                    isOpen={isStepOpen('type')}
                                    isConfirmed={isStepConfirmed('type')}
                                    confirmedSelection={getConfirmedSelection('type')}
                                    hasLearnMore={false}
                                    handleEdit={() => {
                                        handleEditStep('type');
                                    }}
                                    handleEditPrescription={() => {
                                        handleEditStep('prescription');
                                    }}
                                    handleLearnMore={handleLearnMore}
                                    tooltipContent={renderPrescriptionTooltipContent()}
                                    hasPrescriptionStep={hasPrescriptionStep}
                                >
                                    {props.config.prescriptionModule && isSimplePrescription && (
                                        <SimplePrescriptionForm
                                            config={props.config}
                                            isSingleType={isSingleType}
                                            brandBaseUrl={baseURLs.genericImage}
                                            handleSetSelectedType={handleSetSelectedOption}
                                        />
                                    )}
                                    {!isPrescriptionFormOpen && renderTypeStepContent()}
                                </Step>
                                {!isFrameOnlySelected ? (
                                    <>
                                        {hasPrescriptionStep ? (
                                            <Step
                                                key="prescription"
                                                id="prescription"
                                                config={props.config}
                                                isVisible={true}
                                                isOpen={isStepOpen('prescription')}
                                                isConfirmed={isStepConfirmed('prescription')}
                                                confirmedSelection={getConfirmedSelection(
                                                    'prescription'
                                                )}
                                                hasLearnMore={false}
                                                handleEdit={() => {
                                                    handleEditStep('prescription');
                                                }}
                                                handleBackClick={props.handleBackClick}
                                            >
                                                {renderPrescriptionStepContent()}
                                            </Step>
                                        ) : null}
                                        <Step
                                            key="brand"
                                            id="brand"
                                            config={props.config}
                                            isVisible={!props.getSingleBrand()}
                                            isOpen={isStepOpen('brand')}
                                            isConfirmed={isStepConfirmed('brand')}
                                            confirmedSelection={getConfirmedSelection('brand')}
                                            hasLearnMore={true}
                                            handleEdit={() => {
                                                handleEditStep('brand');
                                            }}
                                            handleLearnMore={handleLearnMore}
                                            handleBackClick={props.handleBackClick}
                                        >
                                            {renderBrandStepContent()}
                                        </Step>
                                        <Step
                                            key="thickness"
                                            id="thickness"
                                            config={props.config}
                                            isOpen={isStepOpen('thickness')}
                                            isConfirmed={isStepConfirmed('thickness')}
                                            confirmedSelection={getConfirmedSelection('thickness')}
                                            hasLearnMore={true}
                                            handleEdit={() => {
                                                handleEditStep('thickness');
                                            }}
                                            handleLearnMore={handleLearnMore}
                                            handleBackClick={props.handleBackClick}
                                        >
                                            {renderThicknessStepContent()}
                                        </Step>
                                        <TreatmentStep
                                            config={props.config}
                                            isOpen={isStepOpen('treatments')}
                                            isConfirmed={isStepConfirmed('treatments')}
                                            confirmedSelection={getConfirmedSelection('treatments')}
                                            handleEdit={() => {
                                                handleEditStep('treatments');
                                            }}
                                            handleSetSelectedOption={treatmentOptions => {
                                                handleSetSelectedOption(treatmentOptions);
                                            }}
                                            handleUpdateTotalPriceAndDiscount={currentPackage => {
                                                updateTotalPriceAndDiscount(currentPackage);
                                            }}
                                            handleLearnMore={handleLearnMore}
                                            handleGetInsurancePrice={getInsurancePrices}
                                            handleBackClick={props.handleBackClick}
                                            isMobile={false}
                                        />
                                        {data.warrantyOptions ? (
                                            <Step
                                                key="warranty"
                                                id="warranty"
                                                config={props.config}
                                                isOpen={isStepOpen('warranty')}
                                                isConfirmed={false}
                                                tooltipRef={tooltipRef}
                                                tooltipContent={
                                                    <>
                                                        <span>
                                                            Insure your eyewear with an extended
                                                        </span>
                                                        <span>
                                                            warranty for unlimited repair and
                                                        </span>
                                                        <span>
                                                            replacement at any LensCrafters store.
                                                        </span>
                                                        <a
                                                            href={
                                                                props.config.linksData &&
                                                                props.config.linksData
                                                                    .warrantyLearnMore
                                                                    ? props.config.linksData
                                                                          .warrantyLearnMore
                                                                    : '#'
                                                            }
                                                            className="learn-more"
                                                            tabIndex="0"
                                                            onBlur={() =>
                                                                tooltipRef.current.hideTooltip()
                                                            }
                                                            // eslint-disable-next-line react/jsx-no-target-blank
                                                            target="_blank"
                                                        >
                                                            Learn more
                                                        </a>
                                                    </>
                                                }
                                            >
                                                <StepRadioGroup
                                                    key="warrantyRadioGroup"
                                                    id="warrantyRadioGroup"
                                                    className="warranty-radio-group"
                                                    options={data.warrantyOptions}
                                                    isWarranty={true}
                                                    handleChange={(
                                                        selectedWarrantyKey,
                                                        selectedWarranty
                                                    ) => {
                                                        handleWarrantyStep(
                                                            selectedWarrantyKey,
                                                            selectedWarranty
                                                        );
                                                    }}
                                                    dataAnalyticsAvailableCall="1"
                                                />
                                            </Step>
                                        ) : null}
                                        {currentStep == constants.steps.length - 1 ? (
                                            <>
                                                <Summary
                                                    handleInsuranceClick={props.handleAddInsurance}
                                                    price={
                                                        parseFloat(totalPrice) +
                                                        parseFloat(
                                                            selectedWarranty
                                                                ? selectedWarranty.price
                                                                : 0
                                                        )
                                                    }
                                                    discount={parseFloat(totalDiscount)}
                                                    config={props.config}
                                                    isGVP={props.isGVP}
                                                />
                                            </>
                                        ) : null}
                                    </>
                                ) : null}
                            </>
                        ) : null}
                    </div>
                </div>
            </Scrollbars>
        </>
    );
};

export default StepContainer;
